import { RULER_SIZE_PX } from '../constants/ruler-size'

/** White corner block so horizontal and vertical rulers don't run into each other. */
export function RulerCorner() {
  return (
    <div
      className="absolute left-0 top-0 z-[11] bg-white pointer-events-none"
      style={{
        width: RULER_SIZE_PX,
        height: RULER_SIZE_PX,
      }}
      aria-hidden
    />
  )
}
